var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreviewPasswordProtectedError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110,
    height: 110
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1275 -379)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 866",
    cx: 55,
    cy: 55,
    r: 55,
    transform: "translate(1275 379)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1230"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 409",
    d: "M1350 424.001h-10a4 4 0 01-4-4v-9z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1229"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 410",
    d: "M1343.999 457.5h-27a5.506 5.506 0 01-5.5-5.5v-36a5.506 5.506 0 015.5-5.5h19v8a5.506 5.506 0 005.5 5.5h8v28a5.506 5.506 0 01-5.5 5.5z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 411",
    d: "M1343.999 457a5.005 5.005 0 005-5v-27.5h-7.5a6.006 6.006 0 01-6-6V411h-18.5a5.005 5.005 0 00-5 5v36a5.005 5.005 0 005 5h27m0 1h-27a6.006 6.006 0 01-6-6v-36a6.007 6.007 0 016-6h19.21l.289.29v8.21a5.005 5.005 0 005 5h8.211l.289.289v28.21a6.005 6.005 0 01-6 6z",
    fill: "#d1d1d1"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 412",
    d: "M1335.502 410.708l.707-.707 13.789 13.788-.707.708z",
    fill: "#d1d1d1"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 713",
    d: "M1329.97 450.839l-1.6-1.6a.545.545 0 00-.162-.318v-8.24a5.858 5.858 0 00.592.238 5.61 5.61 0 113.215.123 5.763 5.763 0 00.959-.341l1.484 1.484a.584.584 0 01.164.483.576.576 0 01-.164.479l-2.24 2.243 1.605 1.6a.6.6 0 01.157.483.593.593 0 01-.157.479l-2.89 2.887a.586.586 0 01-.48.161c-.321 0-.321 0-.483-.161zm.644-9.619h-.137zm0 0h.138zm.147 0h.132zm-.3 0h-.127zm.444-.006l.126-.008zm-.59 0l-.12-.014zm.734-.009l.124-.011zm-.882 0l-.121-.011zm1.033-.015l.122-.014zm-1.17 0l-.12-.014zm1.313-.016l.123-.018zm-1.455 0l-.113-.016zm1.591-.019l.129-.022zm-1.726 0l-.1-.017zm1.86-.022l.134-.026zm-2 0l-.1-.019zm2.133-.024l.132-.029zm-2.28 0l-.09-.02zm2.419-.026l.129-.032zm-2.564-.007l-.07-.017zm-.143-.036l-.052-.014zm-.136-.038l-.059-.018zm-.113-.034l-.091-.03zm-.72-5.358a2.4 2.4 0 102.4-2.4 2.408 2.408 0 00-2.4 2.4z",
    fill: "#ababab"
  }))));
}
export default SvgPreviewPasswordProtectedError;